import axios from 'axios'
import urls from '../../util/urls'

const state = {
  listaDeContasReceberDoDia: []
}

const mutations = {
  atualizarListaContasReceberDoDia(state, payload) {
    state.listaDeContasReceberDoDia = payload;
  },

  limparContasReceber(state) {
    state.listaDeContasReceberDoDia = []
  }
}

const actions = {
  recuperarContasReceberDoDia(context) {
    return axios.get(urls.DASHBOARD_RECUPERAR_CONTAS_RECEBER_DO_DIA)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarContasReceberDoDia');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return context.commit('atualizarListaContasReceberDoDia', response.data.lista);
      }
    }).catch((error) => {
      throw error;
    });
  }
}


export default {
  state,
  mutations,
  actions
}